import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';

@Component({
    selector: 'billing-tab',
    templateUrl: './deleteBilling.component.html',
})
export class BillingDeleteComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    numCtrl: FormControl;
    modelCtrl: FormControl;
    dateCtrl: FormControl;
    branchCtrl: FormControl;
    billCtrl: FormControl;
    vouNumCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    AcctypeList = [];
    paymentList = [];
    actModelList = [];
    branchList: any[] = [];
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'stock_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;
    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
      
        this.stockDet = [];
        // this.stockDet['mode'] = 'Add';

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.numCtrl = new FormControl('', [
            Validators.required
        ]);
        this.dateCtrl = new FormControl('', [
            Validators.required
        ]);
        this.billCtrl = new FormControl('', [
            Validators.required
        ]);
        this.vouNumCtrl = new FormControl('', [
            Validators.required
        ]);

    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    ngOnInit(): void {
    
        this.stockDet['voucher_date'] = new Date();

        this.typeList = ['Delete', 'Add to DayBook'];
        this.AcctypeList = ['Testing Bill','Sales Bill','Spare Bill','Advance'];
        

        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });

    }

   
    onDeleteBillingDetails(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };

        
       
        let that = this,
            data = {
                stock_type: this.stockDet['stock_type'],
                client_no: this.stockDet['client_no'],
                bill_no: this.stockDet['bill_no'],
                voucher_no: this.stockDet['voucher_no'],  
                account_type:this.stockDet['account_type'],          
                voucher_date: moment(this.stockDet['voucher_date']).format('YYYY-MM-DD'),
                branch_id:this.stockDet['branch_id'],
                
            };

            if (data.client_no == undefined || data.client_no == '') {
                swal('WARNING', 'Please Enter Client Number');
                return;
            }
            if (data.bill_no == undefined || data.bill_no == '') {
                swal('WARNING', 'Please Enter Bill Number');
                return;
            }
            if (data.voucher_date == undefined) {
                swal('WARNING', 'Please Enter Voucher Date');
                return;
            }
            if (data.branch_id == undefined || data.branch_id == '') {
                swal('WARNING', 'Please Enter Branch');
                return;
            }
            if(data.stock_type=="Add to DayBook"){
                if (data.account_type == undefined || data.account_type == '') {
                swal('WARNING', 'Please Select Account Type');
                return;
            }
            }
            // else{
            //      if (data.voucher_no == undefined) {
            //     swal('WARNING', 'Please Enter Voucher Number');
            //     return;
            //     }
            // }
           
           


           
            if (this.stockDet['stock_type'] == 'Delete') {

                swal({
                    title: 'Are you sure to Delete?',
                    text: 'You will not be able to Recover Bill No: ' + data.bill_no + ' Again!',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Delete!',
                    cancelButtonText: 'No, Keep it'
                }).then(function() {
                    that.isLoading = true;
                    that.isLoadMask = that.commonService
                    .deleteVoucherAmount(data)
                        .then(function(res: any) {
    
                            that.isLoading = false;
                            if (res.success) {
                                that.stockDet = [];
                                swal('SUCCESS', res.message, 'success');
                                //  that.onReset();
                                // that.getStockList();
                            } else {
                                
                                var toast = {
                                    type: 'error',
                                    title: 'ERROR',
                                    body: res.message
                                };
                                that.toasterService.pop(toast);
                            }
                        });
        
                }, function(dismiss) {
        
                }); 
                
            }else {
            this.isLoading = true;
            this.commonService
                .AddVoucherToDayBook(data)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.stockDet = [];
                        swal('SUCCESS', res.message, 'success');
                        //  that.onReset();
                        // that.getStockList();
                    } else {
                        
                        var toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: res.message
                        };
                        that.toasterService.pop(toast);
                    }
                });


            }

    
       
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/deleteBilling/deleteBilling.component.ts